import './stylesheets/default/ProductCard.css'
import './stylesheets/flat/ProductCardFlat.css'
import './stylesheets/neumorphism/ProductCardNeumorphism.css'
import './stylesheets/neobrutalism/ProductCardNeobrutalism.css'
import './stylesheets/glassmorphism/ProductCardGlassmorphism.css'
import Photo1 from './photos/20241221_205817.jpg'
import Photo2 from './photos/20250407_162502.jpg'
import Photo3 from './photos/Snapchat-614274736.jpg'
import Photo4 from './photos/Snapchat-1012693289~2.jpg'
function ProductCard({style}){
    return(
        <div className={`product-card-container-${style}`}>
            <h1 className={`product-card-title-${style}`}>Product Card Example</h1>
            <div className={`product-card-list-container-${style}`}>
<div className={`product-card-${style}`}>    
                <div className={`product-${style}`}>
                    <div className={`photo-container-${style}`}>
                        <div className={`photo-${style}`}>
                            <img src={Photo1} alt="corn" width="100%" height="100%"></img>
                        </div>
                    </div>
                    <div className={`information-container-${style}`}>
                        <h1 className={`text-heading-${style}`}>$123.45</h1>
                        {/* <div className={`tag-${style}`}>
                            <p className={`tag-label-${style}`}>Tag</p>
                        </div> */}
                        <p className={`price-${style}`}>Cornbread With Banana</p>
                        <button className={`product-button-${style}`}>Add To Cart</button>
                        {/* <div className={`description-container-${style}`}>
                            <p className={`description-title-${style}`}>Title</p>
                            <p className={`description-${style}`}>Answer the frequently asked question in a simple sentence, paragraph, or list</p>
                        </div> */}
                    </div>

                </div>
            </div> 
            <div className={`product-card-${style}`}>    
                <div className={`product-${style}`}>
                    <div className={`photo-container-${style}`}>
                        <div className={`photo-${style}`}>
                            <img src={Photo2} alt="corn" width="100%" height="100%"></img>

                        </div>
                    </div>
                    <div className={`information-container-${style}`}>
                        <h1 className={`text-heading-${style}`}>$444.44</h1>
                        {/* <div className={`tag-${style}`}>
                            <p className={`tag-label-${style}`}>Tag</p>
                        </div> */}
                        <p className={`price-${style}`}>Crazy Cornbread</p>
                        <button className={`product-button-${style}`}>Add To Cart</button>
                        {/* <div className={`description-container-${style}`}>
                            <p className={`description-title-${style}`}>Title</p>
                            <p className={`description-${style}`}>Answer the frequently asked question in a simple sentence, paragraph, or list</p>
                        </div> */}
                    </div>

                </div>
            </div> 
            <div className={`product-card-${style}`}>    
                <div className={`product-${style}`}>
                    <div className={`photo-container-${style}`}>
                        <div className={`photo-${style}`}>
                            <img src={Photo3} alt="corn" width="100%" height="100%"></img>

                        </div>
                    </div>
                    <div className={`information-container-${style}`}>
                        <h1 className={`text-heading-${style}`}>$0.00</h1>
                        {/* <div className={`tag-${style}`}>
                            <p className={`tag-label-${style}`}>Tag</p>
                        </div> */}
                        <p className={`price-${style}`}>Judgemental Cornbread</p>
                        <button className={`product-button-${style}`}>Add To Cart</button>
                        {/* <div className={`description-container-${style}`}>
                            <p className={`description-title-${style}`}>Title</p>
                            <p className={`description-${style}`}>Answer the frequently asked question in a simple sentence, paragraph, or list</p>
                        </div> */}
                    </div>

                </div>
            </div> 
            <div className={`product-card-${style}`}>    
                <div className={`product-${style}`}>
                    <div className={`photo-container-${style}`}>
                        <div className={`photo-${style}`}>
                            <img src={Photo4} alt="corn" width="100%" height="100%"></img>

                        </div>
                    </div>
                    <div className={`information-container-${style}`}>
                        <h1 className={`text-heading-${style}`}>$99.99</h1>
                        {/* <div className={`tag-${style}`}>
                            <p className={`tag-label-${style}`}>Tag</p>
                        </div> */}
                        <p className={`price-${style}`}>Perfect Cornbread</p>
                        <button className={`product-button-${style}`}>Add To Cart</button>
                        {/* <div className={`description-container-${style}`}>
                            <p className={`description-title-${style}`}>Title</p>
                            <p className={`description-${style}`}>Answer the frequently asked question in a simple sentence, paragraph, or list</p>
                        </div> */}
                    </div>

                </div>
            </div> 
            </div>
            
        </div>
        
    )
}

export default ProductCard